export const LoginModalActionType = {
    OPEN_LOGIN_MODAL: 'OPEN_LOGIN_MODAL',
    LOGIN_FORM_VALIDATED: 'LOGIN_FORM_VALIDATED',
    INVALID_AIRTEL_NUMBER: 'INVALID_AIRTEL_NUMBER',
    USER_ID: 'USER_ID',
    OTP_SENT_FAILED: 'OTP_SENT_FAILED',
    GET_OTP_BUTTON: 'GET_OTP_BUTTON',
    SENDING_OTP: 'SENDING_OTP'
}